import { Popover } from '@mui/material';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import CrossIcon from '../../../assets/svg/CrossIcon';
import { APPT_TYPES } from '../../../constants';

export const ApptTypeFilter = ({ apptType, onChangeApptType }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const onChange = nextApptType => {
    onChangeApptType(prev => {
      return {
        ...prev,
        apptType: nextApptType,
      };
    });
    onClosePopover();
  };

  const reset = () => {
    onChangeApptType(prev => {
      return {
        ...prev,
        apptType: null,
      };
    });
  };

  const onOpenPopover = e => {
    if (e.target.localName !== 'button') return;
    setAnchorEl(e.currentTarget);
  };

  const onClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const hasApptType = !!apptType;

  return (
    <>
      <button
        className={twMerge(
          'w-[180px] flex items-center justify-between rounded-full py-[11px] px-6 text-brand-900 border border-brand-900 font-medium text-[16px]/[24px] focus-visible:outline-none',
          hasApptType && 'bg-brand-900 text-white',
        )}
        onClick={onOpenPopover}
      >
        {apptType ?? 'Appt Type'}
        {hasApptType && (
          <div onClick={reset}>
            <CrossIcon className="w-4 h-4 text-white" />
          </div>
        )}
      </button>
      <Popover
        open={open}
        slotProps={{
          paper: {
            className:
              '!rounded-xl mt-2 !shadow-[0_4px_20px_0_rgba(17,17,58,0.08)] bg-white w-60',
          },
        }}
        anchorEl={anchorEl}
        onClose={onClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className="p-1 flex flex-col gap-1">
          {APPT_TYPES.map(v => (
            <div
              key={v}
              className="py-2 px-3 cursor-pointer"
              onClick={() => {
                onChange(v);
              }}
            >
              <span className="text-[16px]/[24px] text-base-1000">{v}</span>
            </div>
          ))}
        </div>
      </Popover>
    </>
  );
};
